module.exports = __webpack_public_path__ + "img/third.42b2c83a.png";